import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { SketchPicker } from "react-color"
import { chartColorSetting } from "redux/ducks/Chart"
import chartColors from "../logic/chartColor"
import { CONVERT_OPTIONS } from "../logic/chartConfig"
import _ from "lodash"

interface props {
  type: string
  targetGroup: string
  target: string
  parentId: string
}

const ChartColorPicker = (props: props) => {
  const { targetGroup, target, type, parentId } = props
  const dispatch = useDispatch()
  const colorSettingSelector = (state: any) => state.chart.colorSetting
  const colorSetting = useSelector(colorSettingSelector)
  const [visible, setVisible] = useState(false)
  const [visiblePosition, setVisiblePosition] = useState({
    top: "0px",
    left: "0px",
  })
  const [value, setValue] = useState(
    (() => {
      // reduxのcolorSettingからdefault値を取得。ここでしか使用しないため即時関数で実行。
      if (!CONVERT_OPTIONS[target]) return
      let path = _.join([type, targetGroup, CONVERT_OPTIONS[target][0]], ".")
      let vals = _.get(colorSetting, path).split(";")
      return vals[0]
    })()
  )

  const handleChangeComplete = (color: any) => {
    const rgba = color.rgb
    if (!value) return
    if (value.includes("rgba"))
      return setValue(`rgba(${rgba.r},${rgba.g},${rgba.b},${rgba.a})`)
    setValue(`rgb(${rgba.r},${rgba.g},${rgba.b})`)
  }

  const setColor = () => {
    let newSettings = {}
    if (!CONVERT_OPTIONS[target]) return

    let path = _.join([type, targetGroup, CONVERT_OPTIONS[target][0]], ".")
    let vals = _.get(colorSetting, path).split(";")
    if (vals && vals.length > 0) {
      newSettings = _.merge(
        {},
        colorSetting,
        _.set({}, path, value + (vals[1] ? ";" + vals[1] : ""))
      )
    } else {
      newSettings = _.merge({}, colorSetting)
    }
    // 線が2本ある場合、2本目もサイズを変更する。Reduxで管理しているためforEachで回しても更新が追い付かない。
    if (CONVERT_OPTIONS[target].length === 2) {
      let path2 = _.join([type, targetGroup, CONVERT_OPTIONS[target][1]], ".")
      let vals2 = _.get(colorSetting, path2).split(";")
      if (vals2 && vals2.length > 0) {
        newSettings = _.merge(
          {},
          newSettings,
          _.set({}, path2, value + (vals2[1] ? ";" + vals2[1] : ""))
        )
      } else {
        newSettings = _.merge({}, newSettings)
      }
    }

    dispatch(chartColorSetting(newSettings))
  }

  const _setVisible = (visible: boolean) => {
    setVisible(visible)
    if (!visible) return
    const element = document.getElementById(parentId) as HTMLElement
    const rect = element.getBoundingClientRect()
    setVisiblePosition({
      top: `${rect.top + window.pageYOffset + 32}px`,
      left: `${rect.left + window.pageXOffset + 8}px`,
    })
  }

  useEffect(() => {
    setColor()
  }, [value])

  useEffect(() => {
    setValue(
      (() => {
        if (!CONVERT_OPTIONS[target]) return
        let path = _.join([type, targetGroup, CONVERT_OPTIONS[target][0]], ".")
        let vals = _.get(colorSetting, path).split(";")
        return vals[0]
      })()
    )
  }, [colorSetting])

  return (
    <div className="chart-color-picker">
      <div
        style={{
          background: `${value}`,
          width: "2rem",
          height: "2rem",
          borderRadius: "50%",
        }}
        onClick={() => _setVisible(!visible)}
      />
      {visible ? (
        <div
          style={{
            position: "absolute",
            zIndex: 2,
          }}
        >
          <div
            style={{
              position: "fixed",
              top: "0px",
              right: "0px",
              bottom: "0px",
              left: "0px",
            }}
            onClick={() => _setVisible(false)}
          />
          <div
            style={{
              position: "fixed",
              top: visiblePosition.top,
              left: visiblePosition.left,
            }}
          >
            <SketchPicker
              color={value}
              onChangeComplete={handleChangeComplete}
              width={"24rem"}
            />
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default ChartColorPicker
